"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { TeamsConnectionStatus } from "./types";

/**
 * useTeamsStatus
 *
 * Teams connection status for the current workspace. Gated on workspaceId
 * so the request never fires with an empty one (the backend 400s that).
 */
export function useTeamsStatus(workspaceId: string | undefined) {
  const safeId = workspaceId ?? "";

  const { data, isLoading, isError, refetch } =
    useApiGet<TeamsConnectionStatus>(
      integrationKeys.teams(safeId),
      `/api/teams/status?workspaceId=${encodeURIComponent(safeId)}`,
      undefined,
      {
        enabled: !!safeId,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    );

  return {
    connected: data?.connected ?? false,
    isLoading,
    isError,
    refetch,
  };
}
